import { reduce } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";

interface LikedSongsStore {
  songs: object;
  setSongs: (songs: Song[]) => void;
  setLikeToSong: (songId: string) => void;
  removeLikeFromSong: (songId: string) => void;
}

const likedSongsStore = create<LikedSongsStore>((set) => ({
  songs: new Set<Song>(),

  setSongs: (songs: Song[]) => {
    const objectToStore = reduce(
      songs,
      (acc, song) => ({
        ...acc,
        [song.id]: true,
      }),
      {}
    );
    set({ songs: objectToStore });
  },

  setLikeToSong: (songId: string) => {
    set((state) => {
      const status = !state.songs[songId];
      const updatedObject = { ...state.songs, [songId]: status };
      return { songs: updatedObject };
    });
  },

  removeLikeFromSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: false };
      return { songs: updatedObject };
    });
  },
}));

export default likedSongsStore;
